import React from 'react';
import PropTypes from 'prop-types';

export default function BannerActionText({ children, onClick = () => {} }) {
    return (
        <a className="banner-action-text" onClick={onClick}>
            {children}
        </a>
    );
}

BannerActionText.propTypes = {
    onClick: PropTypes.func,
};
